import { createContext } from "react";

const SymptomsContext = createContext();

export default SymptomsContext;
